'use strict';

/**
 * Fires "view_item_list" event with products.
 * Note: doesn't check if event was fired before (useful when dynamic products are added and event needs to fire again)
 * @param {Element} productTilesWrapper - product tiles inside this element will be selected
 */
function productTileTracking(productTilesWrapper) {
    try {
        const productTiles = productTilesWrapper?.querySelectorAll('[data-tracking-product-tile]');
        if (!productTiles || !productTiles.length) {
            return;
        }

        if (!window.datalayerViewItemList && typeof window.datalayerViewItemList !== 'object') {
            return;
        }

        const event = Object.assign({}, window.datalayerViewItemList);

        if (event?.ecommerce?.items) {
            event.ecommerce.items = [];
        }

        let containerId;

        productTiles.forEach((node) => {
            const tileObj = JSON.parse(node.dataset.trackingProductTile);
            const tileContainer = node.closest('[data-tracking-position]');
            const tilePosition = tileContainer ? parseInt(tileContainer.dataset.trackingPosition) : '';

            if (!containerId) {
                containerId = node.closest('[data-tile-container-id]');
            }

            tileObj.index = tilePosition;
            event.ecommerce.items.push(tileObj);
            if (containerId) {
                event.ecommerce.item_list_id = containerId.dataset.tileContainerId || '';
                event.ecommerce.item_list_name = containerId.dataset.tileContainerId
                    ? containerId.dataset.tileContainerId.replaceAll('-', ' ') : '';
            }
            node.dataset.trackingProductTileProcessed = 'true';
        });
        window.dataLayer.push(event);
    } catch (err) {
        console.error(err);
    }
}

function accountRegistrationTracking(location) {
    window?.dataLayer?.push({
        event: 'sign_up',
        location: `${location}`
    });
}

function checkoutTracking(stage, isPageRefreshed, wasAlreadyOnPage, prevStage) {
    try {
        const trackingView = window?.dataTrackingView;
        window.dataLayer = window.dataLayer || [];
        const dataLayer = window.dataLayer;
        const checkoutStagesGTM = ['shipping', 'customer', 'payment', 'placeOrder'];

        if (trackingView?.page_info?.pageType && checkoutStagesGTM.includes(stage)) {
            trackingView.page_info.pageType = stage;

            let ecommerce = {};

            if (trackingView?.page_info?.ecommerce) {
                ecommerce = trackingView?.page_info?.ecommerce;
                delete trackingView?.page_info?.ecommerce;
            } else if (window.tempPageInfoEcommerce) {
                ecommerce = window.tempPageInfoEcommerce;
            }

            if (!isPageRefreshed) {
                dataLayer.push(trackingView);
            }

            if (isPageRefreshed && !wasAlreadyOnPage) {
                dataLayer.push({ event: 'begin_checkout', ecommerce: ecommerce });
            }

            if (stage === 'payment' && prevStage === 'shipping' && !isPageRefreshed) {
                dataLayer.push({ event: 'add_shipping_info', ecommerce: ecommerce });
            }

            if (stage === 'placeOrder' && prevStage === 'payment' && !isPageRefreshed) {
                dataLayer.push({ event: 'add_payment_info', ecommerce: ecommerce });
            }
        }
    } catch (e) {
        console.error(e);
    }
}

/**
 * Fires "view_item_list" event with products when in viewport.
 * Note: doesn't check if event was fired before (useful when dynamic products are added and event needs to fire again)
 * @param {Element} productTilesWrapper - product tiles inside this element will be selected
 */
function productTileTrackingInViewport(productTilesWrapper) {
    const observer = new IntersectionObserver((entries) => {
        if (entries[0]?.isIntersecting) {
            productTileTracking(productTilesWrapper);
            observer.unobserve(productTilesWrapper);
        }
    }, {
        threshold: 0.50
    });
    observer.observe(productTilesWrapper);
}

module.exports = {
    productTileTracking,
    productTileTrackingInViewport,
    accountRegistrationTracking,
    checkoutTracking
};
